module.exports = __webpack_public_path__ + "img/nature-70.bd021905.jpg";